/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type InsertPaymentTermMutationVariables = Types.Exact<{
  input: Types.PaymentTermInput;
}>;


export type InsertPaymentTermMutation = {
  __typename?: 'Mutation',
  insert: {
    __typename?: 'PaymentTerm',
    id: number
  }
};

export type UpdatePaymentTermMutationVariables = Types.Exact<{
  input: Types.PaymentTermInput;
}>;


export type UpdatePaymentTermMutation = {
  __typename?: 'Mutation',
  update: {
    __typename?: 'PaymentTerm',
    id: number
  }
};

export type DeletePaymentTermMutationVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type DeletePaymentTermMutation = {
  __typename?: 'Mutation',
  delete: boolean
};


export const InsertPaymentTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPaymentTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTermInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertPaymentTermMutation, InsertPaymentTermMutationVariables>;
export const UpdatePaymentTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTermInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;
export const DeletePaymentTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeletePaymentTermMutation, DeletePaymentTermMutationVariables>;